import React from 'react';

import { getEnvVar, getPartner } from '#shared/envs';

export const injectLink: () => React.ReactNode = () => {
  const partner = getPartner();

  return (
    <>
      <link rel="icon" type="image/png" href="/brands/stello/favicon.png" />
      <link rel="apple-touch-icon" sizes="152x152" href="/brands/stello/favicon-apple.png" />
      <link rel="stylesheet" href="/brands/stello/theme.css?v=202402" />
      {!!partner && <link rel="stylesheet" href={partner.stylesheet} />}
    </>
  );
};

export const injectMeta: () => React.ReactNode = () => (
  <>
    <meta itemProp="name" content={getEnvVar('VITE_TITLE_APP')} />
    <meta itemProp="description" content={getEnvVar('VITE_DESCRIPTION')} />
    <meta name="description" content={getEnvVar('VITE_DESCRIPTION')} />
    <meta name="robots" content="none" />
  </>
);

export const injectContentSquare: () => React.ReactElement | '' | false | undefined = () => {
  if ('prod' === getEnvVar('VITE_ENV')) {
    return (
      <script type="text/javascript">
        {`
        (function (c, s, q, u, a, r, e) {
          c.hj = c.hj || function () {
            (c.hj.q = c.hj.q || []).push(arguments)
          };
          c._hjSettings = {hjid: a};
          r = s.getElementsByTagName('head')[0];
          e = s.createElement('script');
          e.async = true;
          e.src = q + c._hjSettings.hjid + u;
          r.appendChild(e);
        })(window, document, 'https://static.hj.contentsquare.net/c/csq-', '.js', 6432080);
        `}
      </script>
    );
  }
};
